import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, switchMap, throwError } from 'rxjs';

import { environment } from "@/environments/environment";

import { AuthService } from '@authcore/auth.service';
import { AuthUtils } from '@authcore/auth.utils';
import { IdentityTokenType } from '@authuser/user.types';

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    // Clone the request object
    let newReq = req.clone();

    //if (window.location.href.indexOf('/sign-out') == -1) {
    //    window.location.href = '/sign-out';
    //    return next(newReq);
    //}

    const authService = inject(AuthService);

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (AuthUtils.token && !AuthUtils.isTokenExpired(authService.token)) {
        if (AuthUtils.refreshToken) {
            newReq = req.clone({
                headers: req.headers
                    .set('authorization', 'Bearer ' + authService.token)
                    .append('client_id', environment.client_id)
                    //.append('_ix', AuthUtils.instanceId)
                    .append('instancecode', AuthUtils.instanceCode)
            });
        }
    }

    // Response
    return next(newReq).pipe(
        catchError((e) =>
        {
            console.warn(e);

            // Catch "403 Forbidden" responses
            if (e instanceof HttpErrorResponse && e.status === 403) {
                //Common.showSnackBarMessageError('Forbidden Access');

                return throwError(() => e);
            }

            // Catch "401 Unauthorized" responses
            if (e instanceof HttpErrorResponse && (e.status === 0 || e.status === 401))
            {
                // force to refresh token
                // issue with api auth expressing 401 whereas token is not yet expired, therefore clientside service fail
                //AuthUtils.token && AuthUtils.refreshToken && AuthUtils.isTokenExpired(authService.token)

                if (authService.token && authService.refreshToken) {
                    const queryParams = {
                        client_id: environment.client_id,
                        grant_type: 'refresh_token',
                        refresh_token: authService.refreshToken
                    };

                    return AuthUtils.getIdentityToken(queryParams).pipe(
                        switchMap(({ access_token, refresh_token }: IdentityTokenType) => {
                            AuthUtils.token = access_token;
                            AuthUtils.refreshToken = refresh_token;

                            return next(
                                req.clone({
                                    headers: req.headers
                                        .set('authorization', 'Bearer ' + authService.token)
                                        .append('client_id', environment.client_id)
                                        //.append('_ix', AuthUtils.instanceId)
                                        .append('instancecode', AuthUtils.instanceCode)
                                })
                            );

                        }),
                        catchError((e) => {
                            console.error(e);

                            switch (true) {
                                case e.status == "0":
                                case e.status == "400":
                                case e.status == "401":
                                case e.status == "403":
                                    var message = '';
                                    if (e.error && !e.error.message && e.error.length > 0)
                                        message = e.error[0].message || e.error[0].phrase;
                                    else if (e.error && e.error.message)
                                        message = e.error.message || e.error.phrase;
                                    else
                                        message = e.message;

                                    //Common.showSnackBarMessageError(message);
                            }

                            //if (e.status == '400') {
                            //    window.location.href = '/sign-out';
                            //    return throwError(() => e);
                            //}

                            return throwError(() => e);
                        })
                    );
                }

                //console.warn(!!AuthUtils.token, !!AuthUtils.refreshToken, !!AuthUtils.isTokenExpired(authService.token));
                //console.warn(AuthUtils.token, !!AuthUtils.refreshToken, !!AuthUtils.isTokenExpired(authService.token));
                //console.warn(AuthUtils.refreshToken);
                //console.warn(AuthUtils.isTokenExpired(authService.token));

                //CommonService.showSnackBarMessageError('Authorization failed.');

                // COMMENT THIS DUE TO TEAMS ISSUE
                //sessionStorage.__reload = parseInt(sessionStorage.__reload || 1);
                //if (parseInt(sessionStorage.__reload) < 2) {
                //    sessionStorage.__reload = parseInt(sessionStorage.__reload) + 1;
                //    setTimeout(() => {
                //        window.location.reload();
                //    }, 1000);
                //}

                return throwError(() => e);
            }

            return throwError(() => e);
        }),
    );
};

